import React from 'react'

import { B5, Icon, SH3, Stack, XStack } from '@zet/design-system'

interface Props {
  guidelines: Array<{
    id: number
    title: string
  }>
  title: string
}

const DocumentUploadGuidelines: React.FC<Props> = ({ guidelines, title }) => {
  return (
    <Stack>
      <SH3 className="pb-1 pt-2 text-base text-[#626874]">{title}</SH3>
      {guidelines.map((item, index) => (
        <XStack key={index} className="items-center">
          <Icon type="DoneFilled" color="#337936" width={20} height={20} />
          <B5 className="text-grays-70 py-1 pl-2 text-sm">{item}</B5>
        </XStack>
      ))}
    </Stack>
  )
}

export default DocumentUploadGuidelines
